import api from './api'

export const ERROR_CVC_DECLINED = 'CVC Declined'
export const ERROR_INVALID_CARD_NUMBER = 'Invalid Card Number'
export const ERROR_REFUSED = 'Refused'
export const ERROR_UNKNOWN = 'Something went wrong'
export const ERROR_ALREADY_PREMIUM = 'User is already premium'
export const ERROR_RECURRING_PAYMENT_FAILED = 'Recurring payment failed'
export const ERROR_STORED_PAYMENT_METHOD_NOT_FOUND =
  'Stored payment method not found'

const apiErrors = [
  ERROR_CVC_DECLINED,
  ERROR_REFUSED,
  ERROR_INVALID_CARD_NUMBER,
  ERROR_ALREADY_PREMIUM,
  ERROR_RECURRING_PAYMENT_FAILED,
  ERROR_STORED_PAYMENT_METHOD_NOT_FOUND,
]

const handleError = (error) => {
  const errorDetailString = JSON.stringify(error)
  for (let apiError of apiErrors) {
    if (errorDetailString.includes(apiError)) {
      throw apiError
    }
  }
  throw ERROR_UNKNOWN
}

export const purchaseProduct = (data) => {
  return api('POST', 'v2/store/make_purchase', data).catch(handleError)
}

export const redirectUrl =
  typeof window !== 'undefined' &&
  `${document.location.origin}/finalize-payment/`
